import { render, staticRenderFns } from "./AddCoinsModal.vue?vue&type=template&id=13421a58&"
import script from "./AddCoinsModal.vue?vue&type=script&lang=js&"
export * from "./AddCoinsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports